import React from 'react'

import { ComputerOutlined } from '@material-ui/icons'
import { Trello, Users } from 'react-feather'

interface RouteChild {
  path: string
  name: string
  icon?: JSX.Element
  badge?: string
}

export interface Route {
  id: string
  path: string
  icon: JSX.Element
  header?: string
  badge?: string
  containsHome: boolean
  open: boolean
  children?: RouteChild[] | null
}

const homeRoute: Route = {
  id: 'Home',
  path: '/',
  icon: <Trello />,
  containsHome: true,
  open: false,
}

const maskRoute: Route = {
  id: 'Mask',
  path: '/admin/mask',
  icon: <Users />,
  containsHome: false,
  open: false,
}

const manageDevicesRoute: Route = {
  id: 'Manage Devices',
  path: '/v2/admin/devices',
  icon: <ComputerOutlined />,
  containsHome: false,
  open: false,
}

export const menu = [homeRoute, maskRoute, manageDevicesRoute]
